module.exports = __webpack_public_path__ + "static/media/background.48afe716.jpg";